// LocationFilter.js
import React, { useState, useEffect } from "react";
import { nanoid } from "nanoid";
import AddressConstraint from "../components/AddressConstraint";
import "./LocationFilter.css";
import { calculateCommuteAPI } from "../services/directions.js";
import { GOOGLE_APIKEY, IS_TEST } from "../consts.js";
import MapComponent from "../components/MapWithHighlights.js";
// import AddressCheckboxList from "../components/AddressCheckBoxList.js";
import CsvFileParser from "../components/CsvFileParser.js";

import { useNavigate } from "react-router-dom";
import logger from "../services/Logger.js";
import { getSchoolRatingForLocations } from "../services/Schools.js";
import styled from "styled-components";
import LocationDetailsTable from "../components/LocationDetailsTable.js";
// import CommuteCheckBoxList from "../components/CommuteCheckBoxList.js";

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  margin: 1rem 0;
`;

function LocationFilter() {
  // const selectedAddresses = useRef();

  const [locationConstraintData, setLocationConstraintData] = useState({});
  const [commuteTime, setcommuteTime] = useState();
  const [error, setError] = React.useState(false);
  // This state will store the parsed data
  // const [data, setData] = useState([]);
  const [allAddresses, setAllAddresses] = useState([]);
  const [calculatedCommuteResults, setCalculatedCommuteResults] = useState([]);
  const [addressConstraints, setAddressConstraints] = useState([]);
  const [schoolRatingsData, setSchoolRatingsData] = useState(null);
  // Add state variables to track when data has been fetched
  const [commuteCalculated, setCommuteCalculated] = useState(false);
  const [schoolRatingsFetched, setSchoolRatingsFetched] = useState(false);
  // Add state to store selected locations from LocationDetailsTable
  const [selectedLocationsFromTable, setSelectedLocationsFromTable] = useState([]);

  const navigate = useNavigate();

  // for testing
  useEffect(() => {
    if (IS_TEST) {
      setAddressConstraints([
        <AddressConstraint
          key={nanoid()}
          alias="father HEB"
          locationAddress="9414 N Lamar Blvd, Austin, TX 78753"
          commuteTime="15"
          commuteTimeDiviation="20"
          onDataChange={handleLocationConstraintChange}
        ></AddressConstraint>,
        <AddressConstraint
          key={nanoid()}
          alias="mother main event"
          locationAddress="13301 N Hwy 183, Austin, TX 78750"
          commuteTime="30"
          commuteTimeDiviation="20"
          onDataChange={handleLocationConstraintChange}
        ></AddressConstraint>,
      ]);
    }
  }, []);

  const handleLocationConstraintChange = (id, data) => {
    console.log("Location constraint data changed, here is the info", id, data);
    setLocationConstraintData((prevData) => ({ ...prevData, [id]: data }));
  };

  const fileDataCallback = (filData) => {
    logger.info("This is the data sent from the file - ", filData);
    //setData(filData);
    logger.info("This is parsed data - ", filData);
    getAllAddresses(filData);
  };

  const calculateCommute = async () => {
    if (!IS_TEST) {
      if (!allAddresses || allAddresses.length === 0) {
        setError("Please select a CSV file to get addresses");
        return;
      }
      if (!locationConstraintData || Object.keys(locationConstraintData).length === 0) {
        setError("Please add at least one location constraint");
        return;
      }
      if (!commuteTime) {
        setError("Please select a date and time for the commute");
        return;
      }
    }
    setError(false);
    const result = await calculateCommuteAPI(allAddresses, locationConstraintData, commuteTime);
    logger.info("This is the calculated commute results - ", result);
    setCalculatedCommuteResults(result);
    setCommuteCalculated(true); // Set flag when commute calculation is done
  };

  const getSchoolRating = async () => {
    const schoolData = await getSchoolRatingForLocations(allAddresses);
    setSchoolRatingsData(schoolData);
    setSchoolRatingsFetched(true); // Set flag when school ratings are fetched
  };

  const getAllAddresses = (parsedData) => {
    var allAddresses = [];
    parsedData.forEach((row) => {
      const address = `${row["Street Number"]} ${row["Street Name"]} ${row["Street Type"]} ${row.City} ${row["State Or Province"]} ${row["Postal Code"]} `;
      if (row.Address) {
        allAddresses.push(address);
      }
    });
    setAllAddresses(allAddresses);
  };

  const handleSelectionChange = (selectedItems) => {
    setSelectedLocationsFromTable(selectedItems);
    console.log("Selected locations from table:", selectedItems);
  };

  useEffect(() => {
    logger.debug("These are all the addresses  - ", allAddresses);
  }, [allAddresses]);

  const addAddressConstraint = () => {
    const key = nanoid();
    logger.info("this is the key - ", key);
    setAddressConstraints([...addressConstraints, <AddressConstraint key={key} id={key} onDataChange={handleLocationConstraintChange}></AddressConstraint>]);
  };

  const naviagateToCalculateRoute = () => {
    // const response = selectedAddresses.current.getCheckedAddresses();
    // console.log("This is response - ", response);
    console.log("This is selectedLocationsFromTable - ", selectedLocationsFromTable);
    const locationsAddressFromTable = selectedLocationsFromTable.map((item) => item.address);
    console.log("This is locationsAddressFromTable - ", locationsAddressFromTable);
    /// TODO - move to shared location as this is common logic
    const subset = calculatedCommuteResults.locationInfoMapping.reduce((result, item) => {
      console.log("This is item - ", item);
      if (locationsAddressFromTable.includes(item.locationAddress)) {
        result.push(item);
      }
      return result;
    }, []);
    console.log("This is the subset - ", subset);
    navigate("/MapRoutes", { state: subset });
  };

  return (
    <div>
      <h3>Load all locations</h3>
      <div>
        <CsvFileParser onFileParsed={fileDataCallback}></CsvFileParser>
      </div>
      <div>
        <h1>List of addresses with commute constraints</h1>
        <p>Fill in a list of addresses such as work that the buyer would like to have a maximum commute to</p>
        <button onClick={addAddressConstraint}>add Address Constraint</button>
        {/* ///TODO- add key to this list*/}
        {addressConstraints.map((address) => address)}
      </div>
      <div>
        <input
          type="datetime-local"
          id="commuteTime"
          name="commuteTime"
          min="09:00"
          max="18:00"
          required
          defaultValue="09:00"
          onChange={(e) => setcommuteTime(e.target.value)}
        />
      </div>

      <div className="App">
        <div className="container">
          <div style={{ marginTop: "3rem" }}>
            {error
              ? error
              : allAddresses.map((e, i) => (
                  <div key={i} className="item">
                    {i + 1} : {e}
                  </div>
                ))}
          </div>
          <ButtonContainer>
            <button onClick={calculateCommute}>Calculate location commute</button>
            <button onClick={getSchoolRating}>Get school rating</button>
          </ButtonContainer>
          <div>
            <h1>Google Maps with Markers and Labels</h1>
            <MapComponent
              locationInfo={calculatedCommuteResults.locationInfoMapping}
              locations={calculatedCommuteResults.commuteResults}
              apiKey={GOOGLE_APIKEY}
            />
          </div>
        </div>
      </div>
      <div>
        {/* Keep the AddressCheckboxList for backward compatibility, but it's no longer used for navigation */}
        {/* {calculatedCommuteResults.locationInfoMapping && (
          <AddressCheckboxList key={nanoid()} items={calculatedCommuteResults.locationInfoMapping} ref={selectedAddresses} />
        )} */}
      </div>
      {/* <div>
        {calculatedCommuteResults.locationInfoMapping && <CommuteCheckBoxList key={nanoid()} items={calculatedCommuteResults} ref={selectedAddresses} />}
      </div> */}
      <button onClick={naviagateToCalculateRoute}>Go to Map Route</button>

      {/* Only show LocationDetailsTable when both operations have been completed */}
      {commuteCalculated && schoolRatingsFetched && calculatedCommuteResults.locationInfoMapping && schoolRatingsData && (
        <LocationDetailsTable commuteData={calculatedCommuteResults} schoolRatingsData={schoolRatingsData} onSelectionChange={handleSelectionChange} />
      )}
    </div>
  );
}

export default LocationFilter;
